/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, StringScalar, render, Mutation, SelectionSet, Field, IdScalar, IntScalar } from "graphql-jsx";
import { ValidTypeScalar } from "GraphQL/Scalars";
import { ValidType } from "constants/ValidType";

type Option = Readonly<{
  id: string;
  name?: string;
  typeClass?: string;
  expose?: number;
  count?: string;
  validCheck?: ValidType;
}>;

export const UpdateRole = async (option: Option) => {
  const $id = <Variable name="id" scalar={<IdScalar />} value={option.id} />;
  const $name = <Variable name="value" scalar={<StringScalar isNullable />} value={option.name} />;
  const $typeClass = <Variable name="typeRoleClass" scalar={<StringScalar isNullable />} value={option.typeClass} />;
  const $expose = <Variable name="expose" scalar={<IntScalar isNullable />} value={option.expose} />;
  const $count = <Variable name="count" scalar={<IntScalar isNullable />} value={option.count} />;
  const $validCheck = <Variable name="valid_check" scalar={<ValidTypeScalar isNullable />} value={option.validCheck} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_ROLE">
      <SelectionSet
        name="updateRole"
        argument={{
          where: {
            role_id: $id
          },
          data: {
            name: $name,
            type_role_class: $typeClass,
            expose: $expose,
            role_count: $count,
            valid_check: $validCheck
          }
        }}
      >
        <Field name="role_id" alias="id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateRole: {
      id: string;
    };
  }>;

  return await clients.role.request<Data>(query, variables);
};
